import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';

import { ErrorBoundaryState } from './Types';

import * as Actions from './Actions';
export type ErrorBoundaryAction = ActionType<typeof Actions>;

const initialState: ErrorBoundaryState = {
    isCommunicating: false,
    data: {
        message: null,
        stack: null,
        info: null,
        showGeneric: true,
    },
    error: false,
};

const reducer: Reducer<ErrorBoundaryState> = (state = initialState, action: ErrorBoundaryAction) => {
    switch (action.type) {
        case getType(Actions.setError):
            return {
                ...state,
                data: {
                    message: action.payload.message,
                    stack: action.payload.stack,
                    info: action.payload.info,
                    showGeneric: action.payload.showGeneric,
                },
            };
        case getType(Actions.sendErrorRequest):
            return {
                ...state,
                isCommunicating: true,
            };
        case getType(Actions.sendErrorSuccess):
            return {
                ...state,
                isCommunicating: false,
                error: false,
            };
        case getType(Actions.sendErrorFailure):
            return {
                ...state,
                isCommunicating: false,
                error: true,
            };
        default:
            return state;
    }
};

export default reducer;
